import type { Result } from '../core/result';
import type { Layout } from './types';
import type { FieldClassesFile } from './generated/fieldClasses';
import { parseFieldClasses } from './fieldClasses';
import committed from './fieldClasses.json';

// tools/fields derives the classes offline from the painting; the build bundles them, so the app
// never decodes the image.
export function loadFieldClasses(layout: Layout): Result<FieldClassesFile, readonly string[]> {
  return parseFieldClasses(committed, layout);
}
